// extracted by mini-css-extract-plugin
export default {"container":"UI7TwX","horizontalSnap":"UWgRCi","dots":"b7sN3K","outside":"tHnvNE","inside":"_nkv6Z","previous":"HYbR2C","next":"sow3aJ"};